// extracted by mini-css-extract-plugin
export default {"box":"formInput_box__Teuw7","box__input":"formInput_box__input__pq4XX","box__label":"formInput_box__label__dJ4nK"};